import React from "react";
import PropTypes from "prop-types";
import DisplayBox from "components/DisplayBox";
import Tags from "components/Tags";

/**
 * RolePrimarySkills
 *
 * @params {Array}    data
 */
const RolePrimarySkills = ({ data, ...props }) => {
  return <DisplayBox numColumns={1} data={SKILLS_DATA(data)} {...props} />;
};

const SKILLS_DATA = (data) => [
  {
    title: null,
    body: data?.primarySkills?.length > 0 && <Tags data={data?.primarySkills} />,
  },
];

RolePrimarySkills.propTypes = {
  data: PropTypes.object,
};

export default RolePrimarySkills;
